import { useState, useRef, useEffect } from "react"; 
import HorizontalMenu from "./HorizontalMenu";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";  
import { MainBg } from "./MainBg";
import { RepoItem } from "./RepoItem";
import { inputBgColor } from "./Scan";
import { FormControlLabel, Checkbox ,Input} from "@mui/material";

import { newSessionUID,getApplicationImage, APPFACTOR,capitalize } from "./commons";
import { ProxySettings, hv} from "./ScanSettingsPage";
import { isValidUrl } from "./newAppComponent";

const UID_CREATE = "10000024-f00d-face-abba-aabbbbaa";

function processCreation(event) {
  try{

    if(!window.createdDataSources) {
      window.createdDataSources = [];
    }
  
    let eventData = JSON.parse(event.data);
    
    if( window.createdDataSources.includes(eventData.id) ) {
      if(eventData.success === false) {
        console.log("setting error",eventData?.error || "Please verify data source configuration");
        window.setIndexSetError(eventData?.error || "Please verify data source configuration");
      }else{
        window.refreshDataSources();
        window.closeAddIndexPage();
      }

      
    }else 
     if(eventData?.id?.indexOf( UID_CREATE) == 0) {
      if(eventData.completed === true && eventData.success === true) {
        let newID = newSessionUID();
        window.createdDataSources.push(newID);
        let data = window.payloadData[eventData.id].payloadData;
  
        let payload = 
          {
            "type": "add_data_source",
            "id": newID,
            "data_source_name": data.name,
            "data_source_type": data.type,
            "base_url": data.url,
            "http_client_settings": data.http_client_settings || null,
          }

          if(data.type === "gitlab") {
            payload.token_secret_ref = window.payloadData[eventData.id].payloadSecret.secret_key;
          } else{
            payload.credentials_secret_ref = window.payloadData[eventData.id].payloadSecret.secret_key;
          }
          
          // console.log("payload",payload);
      
          window.postMessage(
            JSON.stringify(
              {
                type: APPFACTOR.command,
                scanRaw: true,
                payload:
                {
                  ...payload
                }
              }
            )
          )
      }else{
        if(eventData.success === false) {
          console.log("setting error",eventData?.error || "Please verify data source configuration");
          window.setIndexSetError(eventData?.error || "Please verify data source configuration");
        }
      }
    } 
  }catch(e){
    /**/
  }
}


export default function EditIndexPage({ title, isDarkMode, gdata, mData,setOpenAddIndexPage,openAddIndexPage, refreshDataSources,editDataSource, repoName }) {


  const [override, setOverride] = useState( (editDataSource?.http_client_settings !== undefined && editDataSource?.http_client_settings != null && editDataSource.http_client_settings?.http_proxy == null) ? true : false);
  const [activeTab, setActiveTab] = useState( editDataSource?.http_client_settings?.http_proxy == null? "disabled" : "proxy");
  
  useEffect(() => {
    let isOverride = (editDataSource?.http_client_settings !== undefined && editDataSource?.http_client_settings != null && editDataSource.http_client_settings?.http_proxy == null);
    let newActiveTab = isOverride? "disabled" : "proxy";
    
    try{
      if( editDataSource?.http_client_settings != null && editDataSource.http_client_settings?.http_proxy != null){
        newActiveTab = "proxy";
      }
    }catch(e){
      /**/
    }

    setOverride(isOverride);
    setActiveTab( newActiveTab );
  }, [editDataSource]);

  const [indexSetError, setIndexSetError] = useState(null);

  function updateDataSource(data, createNew = false) {

    if(!window.createdDataSources) {
      window.createdDataSources = [];
    }
    
    window.refreshDataSources = refreshDataSources;
    window.setIndexSetError = setIndexSetError;
    window.closeAddIndexPage = () => setOpenAddIndexPage(false);

    try{
      window.removeEventListener("message", processCreation, false);
    }catch(e){
      /**/
    }

    window.addEventListener("message", processCreation, false);

    if(!window.payloadData){
      window.payloadData = {};
    }

    let overrideData = {};
    if( override ) {
      if(activeTab == "disabled"){
        overrideData.http_client_settings = {
          "http_proxy": null,
        }
      }else{
        overrideData.http_client_settings = {
          "ignore_certificate_errors": false,
          "http_proxy": null,
          "http_proxy_auth_secret_ref": ""
        }
      }
    }

    if(createNew) {
      // Credentials changed — create a new secret first; processCreation's
      // UID_CREATE branch sends add_data_source once the secret is confirmed.
      let rndVal = (Math.floor(Math.random() * (9999 - 1000 + 1) + 1000));
      let rID = UID_CREATE + rndVal;

      window.payloadData[rID] = {
        payloadData: {
          ...data,
          ...overrideData
        },
        payloadSecret: {
          "type": "add_secret",
          "id": rID,
          "secret_key": (data.username || data.name) + "_secret" + rndVal,
          "secret": {
              "type": `username_password`,
              "user_name": data.username || "useru_lalilalilulu",
              "password": (data.token || data.password)
          }
        },
      };

      window.postMessage(
        JSON.stringify({
            type: APPFACTOR.command,
            scanRaw: true,
            payload:  window.payloadData[rID].payloadSecret
        })
      );
    }else{
      // Credentials unchanged — keep the existing secret reference.
      let newID = newSessionUID();

      window.createdDataSources.push(newID);

      let payload =
        {
          "type": "add_data_source",
          "id": newID,
          "data_source_name": data.name,
          "data_source_type": data.type,
          "base_url": data.url,
          ...overrideData,
        }

        if(data.type === "gitlab") {
          payload.token_secret_ref = data.token_secret_ref;
        } else{
          payload.credentials_secret_ref = data.credentials_secret_ref;
        }

        window.postMessage(
          JSON.stringify(
            {
              type: APPFACTOR.command,
              scanRaw: true,
              payload:
              {
                ...payload
              }
            }
          )
        )

    }

  }


  const commonFields ={
    name: "",
    // username: "",
    url: "",
  }

  const fieldsConfig = {
    gitlab: {
      type: "gitlab",
     ...commonFields,
     token: "",
    },
    artifactory: {
      type: "artifactory",
      ...commonFields,
      token: "",
    },
    servicenow: {
      type: "servicenow",
      name: "",
      url: "",
      username: "",
      password: "",
    },
    github: {
      type: "github",
      ...commonFields,
    }
  }

  const [currentItemData, setCurrentItemData] = useState(
    // editDataSource ||
    {
    type: editDataSource?.type || "gitlab",
    ...commonFields,
  });

  // Fields the user has explicitly chosen to overwrite (username/password/token).
  // Reset on Cancel so a half-entered credential doesn't linger across reopens.
  const [unlockedFields, setUnlockedFields] = useState(new Set());
  const [resetKey, setResetKey] = useState(0);

  const activeFields = Object.keys(fieldsConfig[currentItemData.type]).filter((field) => field !== "type");

  let sizes ={
    width:777,
    height:777
  }

  const buttonRef = useRef(null);

  return (
  <>
  <Dialog 
  keepMounted
  style={{
    padding: 0,
    margin: 0,
  }}
  slotProps={{
    paper: {
      sx: {
        color:isDarkMode ? "white" : "black",
        opacity: 1,
        padding: 0,
        margin: 0,
        minWidth: sizes.width,
        minHeight: sizes.height,
        background: "transparent !important"
      }
    }
  }}
  
  open={openAddIndexPage} 
  onClose={() => setOpenAddIndexPage(false)}>
    <div
    style={{
      zIndex: -1,
      position: "absolute",
      marginTop:-12,
      marginLeft:-26,
      width: sizes.width +26,
      height: sizes.height + 12,
      overflow:"hidden",
      background: "transparent !important"
    }}
    >
      
    <MainBg isDarkMode={isDarkMode } width={sizes.width + 50} height={sizes.height } ></MainBg>
    </div>
    
    <DialogTitle
    style={{
      paddingTop: 40,
      paddingLeft: 40,
      // margin: 0,
    }}
    >
      <div style={{
        fontSize: 16,
         marginTop: -14
         }}>
      {title?title:"Add custom data source"}
      </div>
      <div style={{
        fontSize: 13,
        opacity: 0.5,
         marginBottom: 32
         }}>
          Data source that will be indexed.
          </div>
      
    </DialogTitle>
    <DialogContent
     sx={{
      padding:0,
      paddingLeft: "40px",
      paddingRight: "40px",
      margin:0,
      maxWidth: "700px",
    }}
    >
<form>

<div style={{
  position: "absolute",
  display : "flex",
  top: 48,
  marginLeft: 294,
  paddingBottom: 20,
}}>
  
    {[
      // "github",
      "gitlab",
      "artifactory",
      "servicenow"
      ].map((type,index) => (TypeSelector (type,setCurrentItemData, editDataSource?.type === type, index, true)))}

        </div>

      {indexSetError && <div style={{
          position: "absolute",
          marginTop: -8,
          fontSize: 11,
          width: "100%",
          height: 42,
          color: "red",
        }}>{indexSetError}</div>
      }

      {activeFields?.map((field,index) => (
        InputElement(
          field,
          isDarkMode,
          setCurrentItemData, 
          index==0,
          (index == activeFields.length-1) ? buttonRef : null,
          setIndexSetError, editDataSource,repoName,
          unlockedFields, setUnlockedFields, resetKey)
        ))}

            <div style={{
              marginTop: 10,
              width: "calc(100% - 110px)",
              height: "180px",
              marginLeft: 60,
              // borderRadius: 8,
              padding: 10,
              paddingBottom: 30,
              borderTop: "1px solid rgba(128,128,128,0.12)",
            }}>
              
              <FormControlLabel
                            style={{
                                marginTop: 0,
                                padding: 0,
                                marginBottom: 0,
                                marginLeft: 0,
                            }}
                            control={
                                <Checkbox
                                    {...(override ? { checked: true } : {})}
                                    onChange={(e) => {
                                        setOverride(e.target.checked)
                                        setActiveTab("disabled");                                       
                                    }}
                                />
                            }
                            label="Override proxy"
                            slotProps={{
                                typography: {
                                    style: {
                                        color: isDarkMode ? "white" : "black",
                                        opacity: 0.5,
                                        fontSize: '13px'
                                    }
                                }
                            }}

                        />

      {override&& 
      <>
       <HorizontalMenu
                            addLabel={false}
                            noScale={true}
                            alignleft={true} 
                            value={activeTab}
                            setValue={setActiveTab}
                            
                        menuValues={["disabled"
                          // ,"proxy"
                        ]}
                        menuItems={[
                            <div
                              style={{ display: "inline-block" }}
                              onClick={() => {
                               
                              }}
                            >Disabled</div>
                            //,<div
                          //   style={{ display: "inline-block" }}
                          //   onClick={() => {
                             
                          //   }}
                          // >Proxy settings</div>
                        ]}

                        onChangeValue={(e, val) => {
                            if( val  ){
                                setActiveTab(val);
                            }
                        }}
                        />

      <div style={{
        // marginLeft: -110,
        marginLeft: 40,
        width: "calc(100% + 120px)",
        marginTop: 20,
        fontSize: 12,
        opacity: 0.5,
      }}>
        <div>Global proxy disabled for this data source.</div>
        <div>Indexing of this data source will not use the global proxy.</div>
        {/* {activeTab=="proxy"&& <ProxySettings onlyDisable={true} isDarkMode={isDarkMode} />} */}
        </div>
        </>
        }


      </div>

      <div style={{
        position: "absolute",
        marginTop: 20,
        marginLeft: 210,
        bottom: -34,
        width: "calc(100% - 220px)",
        height: "180px",
        overflow: "hidden",
      }}>
      <Button
      id="button1"
      ref={buttonRef}
    style={{
      color: isDarkMode ? "rgba(255,255,255,0.75)" : "rgba(0,0,0,0.5)",
      fontSize: 14,
      marginTop: 24,
      // marginLeft:-86,
      maxWidth: 128,
      minWidth: 128,
      maxHeight: 32,
      minHeight: 22,
      padding: "4px !important",
      borderRadius: 4,
      border: isDarkMode ? "1px solid rgba(42,42,42,0)" : "1px solid rgba(0,0,0,0.142)",
    }}
    onClick={(event) => {
      setIndexSetError("")
      event.preventDefault();
      event.stopPropagation();

      let isDirty = false;

      let error = false;
      let updateData={...editDataSource};

      const nameVal = document.getElementById(`${repoName}_input_name`).value;
      const urlVal = document.getElementById(`${repoName}_input_url`).value;

      updateData["name"] = nameVal;
      updateData["url"] = urlVal;

      if(!urlVal || urlVal.trim().length === 0) {
        error = true;
        setIndexSetError(p=> ((p?(p+", "):"") + `Please enter a value for "Url"` ));
      } else if(!isValidUrl(urlVal)) {
        error = true;
        setIndexSetError(p=> ((p?(p+", "):"") + `Please enter a valid URL for "Url"` ));
      }

      if( editDataSource?.type === "servicenow" ) {
        let elUser = document.getElementById(`${repoName}_input_username`);
        let elPass = document.getElementById(`${repoName}_input_password`);

        if( elUser.getAttribute("dirty") == "true" || elPass.getAttribute("dirty") == "true" ) {
          if(!elUser.value || !elPass.value) {
            error = true;
            setIndexSetError(p=> ((p?(p+", "):"") + `Please enter both "Username" and "Password"` ));
          }
          updateData["username"] = elUser.value;
          updateData["password"] = elPass.value;
          isDirty = true;
        }else{
          updateData["credentials_secret_ref"] = editDataSource["credentials_secret_ref"];
        }
      }
      else{
        let elToken = document.getElementById(`${repoName}_input_token`);
        let refField = editDataSource.type === "gitlab" ? "token_secret_ref" : "credentials_secret_ref";

        if( elToken.getAttribute("dirty") == "true" ) {
          if(!elToken.value) {
            error = true;
            setIndexSetError(p=> ((p?(p+", "):"") + `Please enter a value for "Token"` ));
          }
          updateData["token"] = elToken.value;
          isDirty = true;
        }else{
          updateData[refField] = editDataSource[refField];
        }
      }

      if(error == false) {
        window.addNewRepoItem = currentItemData;
        updateDataSource({...updateData}, isDirty);
      }

    }}>UPDATE</Button>
    
    <Button
    style={{
      color: isDarkMode ? "rgba(255,255,255,0.75)" : "rgba(0,0,0,0.5)",
      fontSize: 14,
      marginTop: 24,
      marginLeft:20,
      maxWidth: 128,
      minWidth: 128,
      maxHeight: 32,
      minHeight: 22,
      padding: "4px !important",
      borderRadius: 4,
      border: isDarkMode ? "1px solid rgba(42,42,42,0)" : "1px solid rgba(0,0,0,0.142)",
    }}
    onClick={() => {
      setUnlockedFields(new Set());
      setResetKey(k => k + 1);
      setOpenAddIndexPage(false);
    }}>CANCEL</Button>
    </div>
    </form>     
    </DialogContent>

  </Dialog>
  </>

)

  function TypeSelector(type,setType, active, index, edit = false) {
    const [isSelected, setIsSelected] = useState(false);
    const [lastActiveElement, setLastActiveElement] = useState("input_name");
    return <div
    key={"ts-"+index+type}
    onMouseDown={() => {
      try{
        setLastActiveElement(document.activeElement.id);
      } catch (e) {
        /**/
      }
    }}
    onMouseEnter={() => {
      setIsSelected(true);
    }}
    onMouseLeave={() => {
      if(!isSelected) {
        return;
      }
      setIsSelected(false);
    }}
    style={{
      pointerEvents: !active ? "none" : "auto",
      filter: !active ? "grayscale(100%)" : "none",
      opacity: !active ? 0.2 : 1,
      // filter: (active || isSelected )? "none" : "grayscale(100%)",
      transition: "all 0.2s ease-in-out",
      cursor: "pointer",
      scale: isSelected ? 1 : 0.8,
      width: "64px",
      height: "64px",
      borderRadius: 8,
      marginLeft:10,
      // position: "absolute",
      backgroundColor: isDarkMode ? "rgba(4,4,4,0)" : "rgba(224,224,224,1)",
      top: 14,
      left: 14,
      border: active ? "1.42px solid rgb(217, 28, 33)" : "1.42px solid rgba(255,255,255,0.10)",
    }}
    onClick={() => {
      setType(prev => ({
        ...prev,
        type: type
      }));

      try{
        document.getElementById(lastActiveElement).focus();
      } catch (e) {
        /**/
      }
    }}
    >
      
      <div
        className="arepoLink"
        style={{
          position: "absolute",
          marginTop: 6,
          marginLeft: 6,
          width: 50,
          height: 50,
          minWidth: 30,
          minHeight: 30,
          borderRadius: "99em",
          backgroundColor: isDarkMode ? "rgba(4,4,4,0)" : "rgba(24,24,24,1)",
          backgroundSize: "46px 46px",
          backgroundPosition: "2px 2px",
          backgroundRepeat: "no-repeat",
          fontSize: 10,
          color: "rgba(255,255,255,0.5)",
          backgroundImage: `url(${getApplicationImage(
            type, "AppComponent",
            isDarkMode
          )})`
        }}
      ></div>
      <div style={{
        position: "absolute",
        marginTop: 26,
        marginLeft: 0,
        bottom:-16,
        fontSize: 10,
        width: 64,
        textAlign:"center",
        height: 10,
        textDecoration: active ? "underline 1.42px solid rgb(217, 28, 33)" : "none",
        textTransform:"uppercase",
        }}>{type}</div>
    </div>;
  }

function InputElement( keyVal, isDarkMode, setCurrentItemData, focus,buttonRef, setIndexSetError, editDataSource,repoName, unlockedFields, setUnlockedFields, resetKey) {

  const defValue = editDataSource?(editDataSource[keyVal] || editDataSource["token_secret_ref"]?.split("_secret")[0] || editDataSource["credentials_secret_ref"]?.split("_secret")[0]):  "";
  const isSecretField = keyVal === "username" || keyVal === "password" || keyVal === "token";
  const locked = isSecretField && !!editDataSource && !unlockedFields.has(keyVal);
  // username/password are one credential pair — unlock both together so a
  // partial (new username, stale password) update can't be submitted.
  const pairedKeys = (keyVal === "username" || keyVal === "password") ? ["username","password"] : [keyVal];

  return <div
  key={"in_" + keyVal + "_" + resetKey}
  style={{
    paddingTop: 20,
    paddingLeft: 20,
  }}>
    <div style={{
      textTransform: "capitalize",
      opacity: 0.5,
      textAlign: "right",
      fontSize: 13,
      display: "inline-block",
      minWidth: "80px",
    }}>{keyVal}&nbsp;</div>
    <input
    defaultValue={defValue }
    readOnly={keyVal=="name" || locked}
     autoComplete={'one-time-code'}
     id={`${repoName}_input_${keyVal}`}
     {...(focus == true ? { autoFocus: true} : {})}
     onFocus={() => {
      if(!locked) return;
      setUnlockedFields(prev => {
        const next = new Set(prev);
        pairedKeys.forEach(k => next.add(k));
        return next;
      });
      pairedKeys.forEach(k => {
        const el = document.getElementById(`${repoName}_input_${k}`);
        if(el) {
          el.value = "";
          el.setAttribute("dirty", "true");
        }
      });
    }}
     onKeyDown={(e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        e.stopPropagation();
        if(e.target?.value?.trim()?.length === 0) {
          setIndexSetError(`Please enter a value for "` + capitalize(keyVal) +`"`);
          return;
        }
        setCurrentItemData(prev => ({
          ...prev,
          [keyVal]: e.target.value,
        }) )

        try{
          if(buttonRef) {
            buttonRef.current.focus();
          } else {
            const input = e.target.parentNode.nextSibling.querySelector("input");
            input.focus()
          }
        } catch (err) {
        } 
      }
    }}
    type={(keyVal === "token"  || keyVal === "password") ? "password" : "text"} 
    placeholder={"Enter " + keyVal}
    style={{
      width: "calc(100% - 150px)",
      marginLeft: 10,
      height: hv,
      minHeight: hv,
      maxHeight: hv,
      outline: "none",
      backgroundColor: inputBgColor(isDarkMode),
      color: (keyVal=="name" || keyVal=="username" || keyVal=="password" || keyVal == "token")?"rgba(122,122,122,0.64)":(isDarkMode ? "white" : "black"),
      border: "none",
      boxShadow: "none",
      borderRadius: 8,
      padding: 15,
    }}
    onChange={(e) => {
      setCurrentItemData(prev => ({
        ...prev,
        [keyVal]: e.target.value,
      }))
    }} />


  </div>;
}
}


export { EditIndexPage };